<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addGender()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">
        <button class="top_button">Filter<em class="ti-filter"></em> </button>
        <div class="search">
          <input
            id="nav_search"
            class="input is-medium"
            placeholder="Search for Gender"
            [formControl]="control"
            [appAutocomplete]="autocomplete"
          />
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container *ngIf="(genders | filter: control.value) as result">
                <app-option
                  (click)="clickme(option.id)"
                  *ngFor="let option of result"
                  [value]="option.GenderName"
                >
                  {{ option.GenderName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
          <span class="search_icon"
            ><img src="assets/images/top_nav/Magnifiction.svg" alt=""
          /></span>
        </div>
      </div>
    </div>

    <div class="custom_table_three_row">
      <form [formGroup]="genderForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Gender Name</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="Genders">
          <div
            class="td"
            *ngFor="
              let gender of genderForm.get('Genders')['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="GenderName"
                placeholder="Enter Gender Name"
            /></span>

            <span
              ><button
                class="delete_icon trash"
                (click)="deleteGender(i, gender.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button class="submit_button" (click)="onSubmit(genderForm.value)">
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
